import { createContext, useContext, useMemo } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const ThemeContext = createContext();

const countryThemes = {
  default: {
    primary: "#0262AB",
    bg: "#fdf5fb",
    primaryTitle: "#0262AB",
    primaryColor: "#0262AB", // <--- ADD THIS LINE
    dropdownText: "#fff",
    primaryLight: "#0f8ae9",
    bannerGradient: "linear-gradient(to bottom, #0262AB, #002195)",
    buttonGradient: "linear-gradient(to right, #002195, #0262AB, #00A8FF)",
    buttonGradientHover: "linear-gradient(to right, #001a7f, #01458c, #0080cc)",
    titleGradient: "linear-gradient(to right,  #0262AB, #0e86e2, #0197e2)"
    
  },
  newzealand: {
    primary: "#013d79",
    bg: "#fff6e4",
    primaryColor: "#fdb813",
    primaryTitle: "#013d79",
    dropdownText: "#013d79",
    primaryLight:  "#0f8ae9",
    bannerGradient: "linear-gradient(to bottom, #FDB813, #FFB200)",
    buttonGradient: "linear-gradient(to right, #013d79, #0e5297, #1a6bbd)",
    buttonGradientHover: "linear-gradient(to right, #02315f, #0b3f72, #155392)",
    titleGradient: "linear-gradient(to right,  #013d79, #0e5297, #1a6bbd)"



    // gradient: "linear-gradient(to bottom, #FFB911, #D99A00, #ac7207)",
    // buttonGradient: "linear-gradient(to right, #FFB911, #D99A00, #ac7207)",
    // buttonGradientHover: "linear-gradient(to right, #e4a209, #c58f05, #8b5d08)",
    // titleGradient: "linear-gradient(to right,  #E69A00, #eba313, #eeab24)"
  }
};

export const ThemeManager = ({ children }) => {

  const country = localStorage.getItem("Activecountryversion");

  const selectedTheme =
    country === "New Zealand"
      ? countryThemes.newzealand
      : countryThemes.default;

  const muiTheme = useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            main: selectedTheme.primary
          }
        }
      }),
    [selectedTheme]
  );

  console.log("Current Storage:", localStorage.getItem("Activecountryversion"));
console.log("Selected Theme Primary Color:", selectedTheme.primaryColor);

  return (
    <ThemeContext.Provider value={{ theme: selectedTheme }}>
      <ThemeProvider theme={muiTheme}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useThemeManager = () => useContext(ThemeContext);